import { useEffect } from 'react';
import { type Dispatch } from 'redux';

import updateBingoScheduleAndLobby from '@interlayer/js/custom/components/main/BingoScheduler/helpers/api/updateBingoScheduleAndLobby';
import { resetBingoSchedule } from '@interlayer/js/custom/components/main/BingoScheduler/store/actions';

interface Props {
    dispatch: Dispatch;
    games: Record<string, any>;
    bingoRegion: string;
    casinoName: string;
    lobbyName: string;
    pageSize: number;
}

const useVisibilityChange = ({
    dispatch, games, bingoRegion, casinoName, lobbyName, pageSize
}: Props) => {
    useEffect(() => {
        const handleVisibilityChange = () => document?.visibilityState === 'visible'
            ? updateBingoScheduleAndLobby({ dispatch, games, bingoRegion, casinoName, lobbyName, pageSize })
            : dispatch(resetBingoSchedule());

        if (games) {
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [bingoRegion, casinoName, dispatch, games, lobbyName, pageSize]);
};

export default useVisibilityChange;
